import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // 如果使用了 Vue Router
import ElementPlus from "element-plus";
import "element-plus/dist/index.css"; // Element Plus 的基础样式
import "element-plus/theme-chalk/dark/css-vars.css"; // 使用暗黑主题（可选）
import * as ElIcons from "@element-plus/icons-vue"; // 引入 Element Plus 图标
import { createI18n } from "vue-i18n"; // 导入 vue-i18n
import en from "@/locales/en.json";
import ja from "@/locales/ja.json";
// 引入全局样式
import "@/styles/global.css";

const app = createApp(App);

// 配置 i18n 实例

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: "en", // 默认语言
  fallbackLocale: "en", // 回退语言
  messages: {
    en,
    ja,
  },
});


// 注册 Element Plus 图标组件
for (const [key, component] of Object.entries(ElIcons)) {
  app.component(key, component);
}

app.use(router); // 注册路由（如果有）
app.use(ElementPlus); // 注册 Element Plus
app.use(i18n); // 挂载 i18n 实例
app.mount("#app"); // 挂载应用